export default __webpack_public_path__ + "static/media/Girdle of the Swift Talon.d58a8267.jpg";